/* AW · Viaje del grano — controla el recorrido fijado al hacer scroll */
(function () {
  'use strict';
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');

  function Journey(el) {
    if (el.__jr) return;
    el.__jr = this;
    this.el = el;
    this.n = el.querySelectorAll('.jr-c').length;
    if (!this.n) return;
    this.q = function (s) { return Array.prototype.slice.call(el.querySelectorAll(s)); };
    this.media = this.q('.jr-m');
    this.copy = this.q('.jr-c');
    this.bgs = this.q('.jr-bg');
    this.words = this.q('.jr-word');
    this.rail = this.q('.jr-r');
    this.segs = this.q('.jr-bar b');
    this.num = el.querySelector('[data-jr-num]');
    this.idx = -1;
    this.near = false;
    this.ticking = false;
    el.classList.add('jr-js');
    var self = this;
    this.onScroll = function () {
      if (self.ticking) return;
      self.ticking = true;
      requestAnimationFrame(function () { self.ticking = false; self.update(); });
    };
    this.rail.forEach(function (b) {
      b.addEventListener('click', function () { self.go(+b.getAttribute('data-i')); });
    });
    this.io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        self.near = e.isIntersecting;
        if (self.near) { self.load(Math.max(self.idx, 0)); self.update(); }
        self.playState();
      });
    }, { rootMargin: '60% 0px 60% 0px' });
    this.io.observe(el);
    addEventListener('scroll', this.onScroll, { passive: true });
    addEventListener('resize', this.onScroll);
    this.update(true);
  }

  Journey.prototype.metrics = function () {
    var r = this.el.getBoundingClientRect();
    var vh = innerHeight;
    var total = Math.max(1, this.el.offsetHeight - vh);
    var p = Math.min(1, Math.max(0, -r.top / total));
    var enter = Math.min(1, Math.max(0, 1 - r.top / vh));
    return { p: p, enter: enter, total: total };
  };

  Journey.prototype.update = function (force) {
    var m = this.metrics();
    var f = m.p * this.n;
    var i = Math.min(this.n - 1, Math.floor(f));
    var local = Math.min(1, Math.max(0, f - i));
    var s = this.el.style;
    // espacio del encabezado fijo del tema (cambia de alto al hacer scroll)
    var hdr = document.getElementById('hdr');
    var ht = hdr ? Math.round(hdr.getBoundingClientRect().bottom) : 72;
    if (ht !== this.ht && ht > 0 && ht < 200) { this.ht = ht; s.setProperty('--jr-top', ht + 'px'); }
    s.setProperty('--p', m.p.toFixed(4));
    s.setProperty('--enter', (RM && RM.matches) ? 1 : m.enter.toFixed(4));
    s.setProperty('--local', local.toFixed(4));
    for (var k = 0; k < this.segs.length; k++) {
      this.segs[k].style.setProperty('--f', Math.min(1, Math.max(0, f - k)).toFixed(3));
    }
    if (i !== this.idx || force) this.set(i);
    else if (this.near) this.kick();
  };

  // Si el navegador pausó el video activo (ahorro de energía, pestaña oculta), lo retoma
  Journey.prototype.kick = function () {
    if (RM && RM.matches) return;
    var fig = this.media[this.idx];
    var v = fig && fig.querySelector('video');
    if (v && v.paused && v.getAttribute('src') && v.readyState > 1) {
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    }
  };

  Journey.prototype.set = function (i) {
    var prev = this.idx;
    if (i === prev) return;
    var back = prev > -1 && i < prev;
    var el = this.el;
    el.classList.toggle('is-back', back);
    void el.offsetWidth; // aplica la dirección antes del barrido
    this.media.forEach(function (m, k) {
      m.classList.toggle('is-prev', k === prev);
      m.classList.toggle('is-on', k === i);
    });
    this.copy.forEach(function (c, k) {
      c.classList.toggle('is-out', k === prev);
      c.classList.toggle('is-on', k === i);
      c.setAttribute('aria-hidden', k === i ? 'false' : 'true');
    });
    var tog = function (list) { list.forEach(function (x, k) { x.classList.toggle('is-on', k === i); }); };
    tog(this.bgs); tog(this.words); tog(this.rail);
    this.rail.forEach(function (b, k) { if (k === i) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); });
    if (this.num) this.num.textContent = ('0' + (i + 1)).slice(-2);
    this.idx = i;
    this.count(this.copy[i]);
    if (this.near) this.load(i);
    this.playState();
    var self = this;
    clearTimeout(this.tOut);
    this.tOut = setTimeout(function () {
      self.copy.forEach(function (c, k) { if (k !== self.idx) c.classList.remove('is-out'); });
    }, 900);
  };

  // Carga perezosa: el capítulo activo y el siguiente
  Journey.prototype.load = function (i) {
    [i, i + 1].forEach(function (k) {
      var fig = this.media[k];
      var v = fig && fig.querySelector('video[data-src]');
      if (v) {
        var self = this;
        v.src = v.getAttribute('data-src'); v.removeAttribute('data-src');
        v.addEventListener('canplay', function () { self.playState(); }, { once: true });
        v.load();
      }
    }, this);
  };

  Journey.prototype.playState = function () {
    var self = this;
    var still = RM && RM.matches;
    this.media.forEach(function (fig, k) {
      var v = fig.querySelector('video');
      if (!v || !v.getAttribute('src')) return;
      if (self.near && k === self.idx && !still) {
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      } else if (k !== self.idx || !self.near) {
        // el capítulo anterior sigue visible durante el barrido
        setTimeout(function () { if (k !== self.idx) v.pause(); }, 1300);
        if (!self.near) v.pause();
      }
    });
  };

  // Cifras que cuentan hasta su valor (solo números enteros; lo demás se muestra tal cual)
  Journey.prototype.count = function (art) {
    if (!art || (RM && RM.matches)) return;
    art.querySelectorAll('[data-jr-count]').forEach(function (dt) {
      var raw = dt.getAttribute('data-jr-count');
      var mm = raw.match(/^(\D*)(\d{1,5})(\D*)$/);
      if (!mm) return;
      var to = +mm[2], t0 = null, dur = 1400;
      var step = function (ts) {
        if (!t0) t0 = ts;
        var e = Math.min(1, (ts - t0) / dur);
        e = 1 - Math.pow(1 - e, 3);
        dt.textContent = mm[1] + Math.round(to * e) + mm[3];
        if (e < 1) requestAnimationFrame(step);
      };
      dt.textContent = mm[1] + '0' + mm[3];
      setTimeout(function () { requestAnimationFrame(step); }, 350);
    });
  };

  Journey.prototype.go = function (i) {
    var m = this.metrics();
    var top = this.el.getBoundingClientRect().top + scrollY;
    var y = top + ((i + 0.08) / this.n) * m.total;
    scrollTo({ top: Math.round(y), behavior: (RM && RM.matches) ? 'auto' : 'smooth' });
  };

  Journey.prototype.destroy = function () {
    removeEventListener('scroll', this.onScroll);
    removeEventListener('resize', this.onScroll);
    if (this.io) this.io.disconnect();
    this.el.__jr = null;
  };

  function init(root) {
    (root || document).querySelectorAll('[data-aw-jr]').forEach(function (el) { new Journey(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Editor de temas
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('[data-aw-jr]'); if (el && el.__jr) el.__jr.destroy();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest('[data-aw-jr]');
    if (el && el.__jr) el.__jr.go(+e.target.getAttribute('data-i'));
  });
})();
